import { getReduxSelector } from '@gymaholic/packages'
import { TRAINING_USERS_PATH } from 'modules/training/modules/training-users/constants/index.js'
import { getNewCustomerDiscountExpiresAtFromLocalStorageUtil } from 'modules/training/modules/training-users/utils/getNewCustomerDiscountExpiresAtFromLocalStorage/index.js'

export const getNewCustomerDiscountExpiresAtUserSelect = state => {
  return (
    getReduxSelector(TRAINING_USERS_PATH.NEW_CUSTOMER_DISCOUNT_EXPIRES_AT)(state) ||
    getNewCustomerDiscountExpiresAtFromLocalStorageUtil()
  )
}
